'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { Suspense, useEffect, useState } from 'react';
import { isPopupLabOn } from '@/components/dev/PopupLabGate';
import { isFormPath } from './exit-v2-messages';

/**
 * Mounts the exit popup on the demo form and the pricing form. Those pages are on ConditionalNavigation's "no chrome"
 * list, so GlobalWidgets (which carries the popup everywhere else) never renders there. Lives in the root layout, outside
 * that wrapper. Skipped in the popup lab (the lab mounts its own copy) so there is never a second popup.
 */
const ExitPopupV2 = dynamic(() => import('./ExitPopupV2'), { ssr: false, loading: () => null });

export function FormExitMount() {
  const path = usePathname() || '/';
  const [ready, setReady] = useState(false);
  const on = isFormPath(path);
  useEffect(() => {
    if (!on || isPopupLabOn()) return;
    if ('requestIdleCallback' in window) {
      const h = requestIdleCallback(() => setReady(true), { timeout: 2000 });
      return () => cancelIdleCallback(h);
    }
    const t = setTimeout(() => setReady(true), 150);
    return () => clearTimeout(t);
  }, [on]);
  if (!on || !ready) return null;
  return <Suspense fallback={null}><ExitPopupV2 /></Suspense>;
}
